import { __awaiter } from "tslib";
import React from 'react';
import LabSimService, { StateContext } from '../services/LabSimService';
import PageFooter from '../partials/PageFooter';
import SyncHistory from '../controls/gradesync/SyncHistory';
import { T } from '@testout/labsim-ui-atomics';
import 'react-sweet-progress/lib/style.css';
import styles from './SyncGrades.module.less';
export default React.forwardRef((props, ref) => (React.createElement(StateContext.Consumer, null, (stateContext) => React.createElement(SyncGrades, Object.assign({}, props, { context: stateContext })))));
const generalInstructions = 'Syncing grades usually takes 20-30 minutes. For multiple classes or large class sizes the grade sync can take up to 60 minutes.';
const manualGradeSyncInstructions = (React.createElement("div", null, "You can sync manually to ensure that your grades are up to date. Clicking the \"Sync Grades Manually\" button will start an on-demand course-level sync for the assignments tied to this LMS course. Grades passed back will reflect the latest or highest grade a student has achieved on an assignment based on your configuration with your CompTIA contact."));
const syncScoresInstructions = (React.createElement("div", null, "By default, we do not sync late scores (based on the assignment due date in Canvas), but you can allow it by checking this box."));
const scoresOutsideDatesInstructions = (React.createElement("div", null, "By default, scores outside available dates are ignored by the synchronization process. Check this box to include scores outside the available date range."));
class SyncGrades extends React.Component {
    constructor(props) {
        super(props);
        this.requestGradeSync = () => __awaiter(this, void 0, void 0, function* () {
            this.setState({ isSyncBtnDisabled: true });
            try {
                let data;
                if (this.props.context.isIntegrationLTIAdvantage()) {
                    data = yield LabSimService.manualSyncGrades();
                }
                else {
                    data = yield LabSimService.syncGrades(this.state.isSyncLate, true, this.state.isCheckLockDates);
                }
                if (data) {
                    console.log('Grade Sync result', data.error);
                    this.setState({
                        error: data.error,
                        syncHistoryRebuildKey: Date.now(),
                    });
                }
            }
            catch (e) {
                console.log('Grade Sync Failed', JSON.stringify(e));
                this.setState({ manSyncFailed: true });
            }
            this.setState({ working: false, isSyncBtnDisabled: false });
        });
        this.onSyncLateChange = () => {
            this.setState({ isSyncLate: !this.state.isSyncLate });
        };
        this.onLockDatesCheckChange = () => {
            this.setState({ isCheckLockDates: !this.state.isCheckLockDates });
        };
        this.handleDisableSyncButton = (disable) => {
            this.setState({ isSyncBtnDisabled: disable });
        };
        this.onModalClose = () => this.setState({ modalOpen: false });
        this.gradeManuallyAndCloseModal = () => __awaiter(this, void 0, void 0, function* () {
            yield this.requestGradeSync();
            this.onModalClose();
        });
        this.state = {
            isSyncBtnDisabled: true,
            isCheckLockDates: true,
            isSyncLate: false,
            working: true,
            syncHistoryRebuildKey: Date.now(),
            isAutomaticSync: false,
            isAutoSyncLate: false,
            isAutoSyncLockDates: false,
            manSyncFailed: false,
        };
    }
    componentDidMount() {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            const autoSyncSettings = yield LabSimService.getAutomaticSyncSettings();
            this.setState({
                allowAutoSync: (_a = autoSyncSettings.isFeatureEnabled) !== null && _a !== void 0 ? _a : false,
                isAutomaticSync: (_b = autoSyncSettings.isActive) !== null && _b !== void 0 ? _b : false,
                isAutoSyncLate: (_c = autoSyncSettings.isIncludeLate) !== null && _c !== void 0 ? _c : false,
                isAutoSyncLockDates: (_d = autoSyncSettings.isIncludeNotAvailable) !== null && _d !== void 0 ? _d : false,
                isLatestGradeEnabled: (_e = autoSyncSettings.isLatestGradeEnabled) !== null && _e !== void 0 ? _e : false,
            });
        });
    }
    render() {
        let extraInstructions = '';
        let isManualSyncOnly = false;
        if (this.props.context.isFamilyDesire2Learn()) {
            extraInstructions =
                'Please make sure your Brightspace course has a start date. Without a start date, sync scores will not occur.';
        }
        if (this.props.context.isIntegrationLTIAdvantage()) {
            isManualSyncOnly = true;
        }
        return (React.createElement("div", { className: styles.container },
            React.createElement("div", null,
                React.createElement(T.Text.H1, { automationId: 'title', variation: T.Text.Variation.H1_Large }, "Grade Sync Center"),
                React.createElement("div", null,
                    React.createElement(T.InfoBox, { automationId: 'info' },
                        React.createElement(T.InfoBox.Body, null, generalInstructions)),
                    !!extraInstructions && (React.createElement(T.Text.P, { automationId: 'extraInstructions' }, extraInstructions)),
                    React.createElement("div", { className: styles.gradeSyncSettings },
                        React.createElement("div", { className: styles.header },
                            React.createElement(T.Text.H2, { automationId: 'title2' },
                                "Manual Grade Sync \u00A0",
                                React.createElement(T.Popover, { placement: 'bottom-end', automationId: 'manualSyncInst' },
                                    React.createElement(T.Popover.Trigger, null,
                                        React.createElement(T.IconButton, { automationId: 'btn', iconVariation: T.IconVariation.QuestionCircle, screenReaderDescription: 'Manual Grade Sync Instructions' })),
                                    React.createElement(T.Popover.Content, { className: styles.popover },
                                        React.createElement(T.Popover.Body, null, manualGradeSyncInstructions)))),
                            React.createElement(T.Text.P, { automationId: 'campusSettingText' },
                                "Your campus is setup to return the",
                                ' ',
                                this.state.isLatestGradeEnabled ? 'latest' : 'highest',
                                " grade results for your students."),
                            isManualSyncOnly && (React.createElement(T.Text.P, { automationId: 'ltiAdvantageManualSyncText' }, "LTI Advantage manual sync runs at the course level and reuses the same background sync process as internal support tools."))),
                        !isManualSyncOnly && (React.createElement("div", null,
                            React.createElement(T.Input.Checkbox, { checked: this.state.isSyncLate, onChange: this.onSyncLateChange, name: 'syncLateCheck', automationId: 'syncLateCheck' },
                                "Include scores submitted after the assignment due date",
                                React.createElement(T.Popover, { placement: 'bottom-end', automationId: 'syncLateCheckPop' },
                                    React.createElement(T.Popover.Trigger, null,
                                        React.createElement(T.IconButton, { automationId: 'btn', iconVariation: T.IconVariation.QuestionCircle, screenReaderDescription: 'Sync scores after due date instructions' })),
                                    React.createElement(T.Popover.Content, { className: styles.popover },
                                        React.createElement(T.Popover.Body, null, syncScoresInstructions)))))),
                        !isManualSyncOnly && (React.createElement("div", null,
                            React.createElement(T.Input.Checkbox, { checked: !this.state.isCheckLockDates, onChange: this.onLockDatesCheckChange, name: 'lockDatesCheck', automationId: 'lockDatesCheck' },
                                "Include scores submitted outside available dates",
                                React.createElement(T.Popover, { placement: 'bottom-end', automationId: 'lockDatesCheckPop' },
                                    React.createElement(T.Popover.Trigger, null,
                                        React.createElement(T.IconButton, { automationId: 'btn', iconVariation: T.IconVariation.QuestionCircle, screenReaderDescription: 'Sync scores outside availabe dates instructions' })),
                                    React.createElement(T.Popover.Content, { className: styles.popover },
                                        React.createElement(T.Popover.Body, null, scoresOutsideDatesInstructions)))))),
                        React.createElement("div", { className: styles.history },
                            React.createElement("div", null,
                                React.createElement(T.Text.H3, { automationId: 'historyTitle' }, "Manual Grade Sync History"),
                                React.createElement(T.LinkButton, { automationId: 'synchronizeButton', onClick: this.requestGradeSync, disabled: this.state.isSyncBtnDisabled },
                                    React.createElement(T.IconText, { automationId: 'text', variation: T.Text.Variation.Inherit, leftIconVariation: T.IconVariation.Sync }, "Sync Grades Manually"))),
                            React.createElement(SyncHistory, { disableSyncCallback: this.handleDisableSyncButton, key: this.state.syncHistoryRebuildKey }))),
                    this.props.context.serverState && !this.props.context.serverState.syncOnly && (React.createElement(T.ActionToolbar, null,
                        React.createElement(T.ActionToolbar.Group, { right: true },
                            React.createElement(T.Button, { automationId: 'backBtn', onClick: this.props.history.goBack, variation: T.ButtonVariation.Secondary }, "Go Back"))))),
                this.state.modalOpen && (React.createElement(T.SimpleDialog, { buttons: [
                        {
                            isDialogCancel: true,
                            text: "Don't Sync Manually",
                            automationId: 'cancel',
                            onClick: this.onModalClose,
                        },
                        {
                            onClick: this.gradeManuallyAndCloseModal,
                            text: 'Sync Grades Manually',
                            automationId: 'syncGradesBtn',
                        },
                    ], className: styles.modal, onClose: this.onModalClose, automationId: 'autoModal', title: 'Automatic Grade Sync' },
                    React.createElement(T.Text.P, { automationId: 'textModal' }, "Before we start syncing future grades, you will want to sync past work that was completed by your students. Please run a manual sync to bring your gradebook up to date."),
                    React.createElement("div", null,
                        React.createElement(T.Input.Checkbox, { checked: this.state.isSyncLate, onChange: this.onSyncLateChange, name: 'syncLateCheckModal', automationId: 'syncLateCheckModal' },
                            "Include scores submitted after the assignment due date",
                            React.createElement(T.Popover, { placement: 'bottom-end', automationId: 'syncLateCheckModalPop' },
                                React.createElement(T.Popover.Trigger, null,
                                    React.createElement(T.IconButton, { automationId: 'btn', iconVariation: T.IconVariation.QuestionCircle, screenReaderDescription: 'Sync scores after due date instructions' })),
                                React.createElement(T.Popover.Content, { className: styles.popover },
                                    React.createElement(T.Popover.Body, null, syncScoresInstructions))))),
                    React.createElement("div", null,
                        React.createElement(T.Input.Checkbox, { checked: !this.state.isCheckLockDates, onChange: this.onLockDatesCheckChange, name: 'lockDatesCheckModal', automationId: 'lockDatesCheckModal' },
                            "Include scores submitted outside available dates",
                            React.createElement(T.Popover, { placement: 'bottom-end', automationId: 'lockDatesCheckModalPop' },
                                React.createElement(T.Popover.Trigger, null,
                                    React.createElement(T.IconButton, { automationId: 'btn', iconVariation: T.IconVariation.QuestionCircle, screenReaderDescription: 'Sync scores outside availabe dates instructions' })),
                                React.createElement(T.Popover.Content, { className: styles.popover },
                                    React.createElement(T.Popover.Body, null, scoresOutsideDatesInstructions)))))))),
            this.state.manSyncFailed && (React.createElement(T.SimpleToast, { onHidden: () => this.setState({ manSyncFailed: false }) }, "Manual Sync Failed")),
            React.createElement("div", null,
                React.createElement(PageFooter, null))));
    }
}
//# sourceMappingURL=SyncGrades.js.map